import gql from 'graphql-tag';

const GET_USER_VALIDATION = gql`
  query getUsersFeed($size: Int, $page: Int, $sort: [SortInput], $filters: [FilterInput], $fields: [String], $or: OrInput) {
    getUsersFeed(size: $size, page: $page, sort: $sort, filters: $filters, fields: $fields, or: $or) {
      count
      page
      results {
        ... on Picker {
          id
          email
          statusUser
        }
      }
    }
  }`;


export default GET_USER_VALIDATION;
